function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { useEffect, useState } from "react";
import { Desktop, useTranslation } from "@edreamsodigeo/frontend-core";
import { Alert, Body, Box, ButtonWithLoading, Field, Flex, Glyph, Heading, InnerLabel, Input, ValidationErrorMessage } from "@edreamsodigeo/prisma-design-system";
import useCustomField from "../../clientSide/hooks/useCustomFields/useCustomField";
import { useDevice } from "../../clientSide/hooks/useDevice";
import useGenerateTripToken from "../../clientSide/hooks/useGenerateTripToken";
import { useGetActionsFromUrl } from "../../clientSide/hooks/useGetActionsFromUrl";
import useGetSuccessAuthRedirection from "../../clientSide/hooks/useGetSuccessAuthRedirection/useGetSuccessAuthRedirection";
import useTrackingBookingAuth from "../../clientSide/hooks/useTrackingBookingAuth";
import BOOKING_AUTHENTICATION_DATA from "./config/data";
const BookingAuthentication = () => {
  const {
    trackEventBookingAuth
  } = useTrackingBookingAuth();
  const {
    isMobile
  } = useDevice();
  const action = useGetActionsFromUrl();
  const [error, setError] = useState("");
  const [requested, setRequested] = useState(false);
  const {
    t
  } = useTranslation();
  const {
    field: emailField,
    error: errorEmail
  } = useCustomField({
    id: BOOKING_AUTHENTICATION_DATA.email.id,
    errors: BOOKING_AUTHENTICATION_DATA.email.errors,
    trackEvent: label => trackEventBookingAuth(label, true)
  });
  const {
    field: bookingReferenceField,
    error: errorBookingReference
  } = useCustomField({
    id: BOOKING_AUTHENTICATION_DATA.bookingReference.id,
    errors: BOOKING_AUTHENTICATION_DATA.bookingReference.errors,
    trackEvent: label => trackEventBookingAuth(label, true)
  });
  const emailInvalid = !!emailField?.validationProps?.invalid;
  const bookingReferenceInvalid = !!bookingReferenceField?.validationProps?.invalid;
  const {
    mutate,
    data: tokenData,
    loading: isTokenLoading,
    errors
  } = useGenerateTripToken();
  const redirectionUrl = useGetSuccessAuthRedirection(tokenData?.generateTripToken?.token);
  const onFindBooking = () => {
    trackEventBookingAuth("find_booking_clicks");
    if (emailField?.inputProps?.value && bookingReferenceField?.inputProps?.value && !emailInvalid && !bookingReferenceInvalid) {
      setError("");
      setRequested(true);
      mutate({
        email: emailField?.inputProps?.value,
        bookingId: bookingReferenceField?.inputProps?.value
      });
    } else {
      emailField?.inputProps?.onBlur();
      bookingReferenceField?.inputProps?.onBlur();
    }
  };
  useEffect(() => {
    if (requested && !isTokenLoading) {
      if (tokenData?.generateTripToken?.token) {
        window.open(redirectionUrl, "_self");
      } else {
        trackEventBookingAuth(BOOKING_AUTHENTICATION_DATA.global.INVALID_REQUEST.track, true);
        setError(BOOKING_AUTHENTICATION_DATA.global.INVALID_REQUEST.key);
      }
      setRequested(false);
    }
  }, [isTokenLoading, tokenData, setError, setRequested, requested, errors, trackEventBookingAuth, action, redirectionUrl]);
  useEffect(() => {
    setError("");
  }, [emailField?.inputProps?.value, bookingReferenceField?.inputProps?.value, setError]);
  return /*#__PURE__*/React.createElement(Flex, {
    flexDirection: "column"
  }, /*#__PURE__*/React.createElement(Desktop, null, /*#__PURE__*/React.createElement(Heading, {
    type: "2",
    color: "neutral.100",
    weight: "medium"
  }, t("mytripslogin.booking.authentication.title"))), /*#__PURE__*/React.createElement(Box, {
    mt: [0, "base"]
  }, /*#__PURE__*/React.createElement(Field, emailField?.fieldProps, /*#__PURE__*/React.createElement(Input, _extends({}, emailField?.inputProps, {
    invalid: !!error || emailInvalid,
    id: BOOKING_AUTHENTICATION_DATA.email.id,
    label: /*#__PURE__*/React.createElement(InnerLabel, emailField?.labelProps, /*#__PURE__*/React.createElement(Body, null, t("mytripslogin.booking.authentication.email.label")))
  }))), /*#__PURE__*/React.createElement(ValidationErrorMessage, _extends({}, emailField?.validationProps, {
    invalid: !error && emailInvalid,
    htmlFor: /*#__PURE__*/React.createElement(Glyph, {
      category: "UIActions",
      name: "ClearCircle",
      size: "small"
    })
  }), t(errorEmail))), /*#__PURE__*/React.createElement(Box, {
    mt: "base"
  }, /*#__PURE__*/React.createElement(Field, bookingReferenceField?.fieldProps, /*#__PURE__*/React.createElement(Input, _extends({}, bookingReferenceField?.inputProps, {
    invalid: !!error || bookingReferenceInvalid,
    id: BOOKING_AUTHENTICATION_DATA.bookingReference.id,
    label: /*#__PURE__*/React.createElement(InnerLabel, bookingReferenceField?.labelProps, t("mytripslogin.booking.authentication.reference.label"))
  }))), /*#__PURE__*/React.createElement(ValidationErrorMessage, _extends({}, bookingReferenceField?.validationProps, {
    invalid: !!error || bookingReferenceInvalid,
    htmlFor: /*#__PURE__*/React.createElement(Glyph, {
      category: "UIActions",
      name: "ClearCircle",
      size: "small"
    })
  }), t(error || errorBookingReference))), /*#__PURE__*/React.createElement(Alert, {
    mt: "base",
    mb: "big",
    theme: "soft",
    type: "informative"
  }, /*#__PURE__*/React.createElement(Flex, null, /*#__PURE__*/React.createElement(Flex, {
    mr: "2x_small",
    minWidth: "24px"
  }, /*#__PURE__*/React.createElement(Glyph, {
    category: "Alerts",
    name: "InfoCircle",
    size: "medium"
  })), /*#__PURE__*/React.createElement(Flex, {
    flexDirection: "column",
    gap: "1x_small"
  }, /*#__PURE__*/React.createElement(Body, {
    type: "base"
  }, t("mytripslogin.booking.authentication.info"))))), /*#__PURE__*/React.createElement(ButtonWithLoading, {
    type: isMobile ? "primary" : "secondary",
    onClick: onFindBooking,
    loading: isTokenLoading
  }, t("mytripslogin.booking.authentication.cta")));
};
export default BookingAuthentication;